<template>
  <section class="sku_section sku-buy-type" v-if="showList.length > 1">
    <div class="section_title">
      <span class="title">购买方式</span>
    </div>
    <div class="section_content">
      <div
        class="sku_btn"
        v-for="(buyType, idx) in showList"
        :key="'idx' + idx"
        :class="{
          'sku_btn--checked': buyType.id == type
        }"
        @click="selectBuyType(buyType)"
      >
        <span
          class="buy-type-label"
          tabindex="0"
          :aria-label="
            buyType.id == type
              ? '已选中,' + buyType.name + (buyType.id == 2 && maxReward ? ',' + maxReward : '')
              : '未选中,' + buyType.name + (buyType.id == 2 && maxReward ? ',' + maxReward : '') + ',点按两次可选中'
          "
        >
          {{ buyType.name }}
        </span>
        <span class="badge" v-if="buyType.id == 2 && maxReward" aria-hidden="true">
          <i class="text">{{ maxReward }}</i>
        </span>
        <span class="badge" v-if="buyType.id == 3 && operatorSubsidy" aria-hidden="true">
          <i class="text">{{ operatorSubsidy }}</i>
        </span>
      </div>
    </div>
    <collapse>
      <div v-if="operatorSubsidyTips && type == 3" class="tips-collapse">
        <div class="buy_type_tips fs-30" role="region" >
          {{ operatorSubsidyTips }}
        </div>
      </div>
    </collapse>
  </section>
</template>

<script>
import skuEventBus from '../../eventBus'
export default {
  name: 'SkuBuyType',
  props: {
    type: Number,
    allowBuyTypes: {
      type: Array,
      default: ()=>{
        return [1]
      }
    },
    maxReward: [Number, String],
    operatorSubsidy: [Number, String],
    operatorSubsidyTips: String,
    trackData: Object
  },
  data() {
    return {
      // 防重点
      buyTypeList: [
        {
          id: 1,
          name: '立即购买'
        },
        {
          id: 2,
          name: '以旧换新'
        },
        {
          id: 3,
          name: '移动用户特惠'
        }
      ]
    }
  },
  computed: {
    showList(){
      return this.buyTypeList.filter(item=>{
        return this.allowBuyTypes.includes(item.id)
      })
    }
  },
  methods: {
    // 调整购买数量
    selectBuyType(type) {
      if (type.id == this.type) return
      // 从移动特惠切到其他方式 以及 从其他方式切到移动特惠 等同于sku规格更新，走skuEventBus更新商详页所有地方的展示&计价逻辑
      // 从立即购买-以旧换新的切换，仅在以旧换新弹层内隐藏加价购模块，不影响计价和商详页页面展示，更新已选弹层buyType即可
      if(type.id == 3 || this.type == 3) {
        skuEventBus.$emit('selectBuyType', {
          buyType: type.id,
          oldBuyType: this.type
        })
      } else {
        this.$emit('typeChange', type.id, this.type)
      }
      // 点击埋点
      let data = this.trackData
      data.button = type.name
      this.$track(data)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
